const mineRouterView = r => require.ensure([], () => r(require('@/page/mine/mineView')), 'mineRouterView');
const mine = r => require.ensure([], () => r(require('@/page/mine/mine')), 'mine');
const mineRouter={
  path:'',
  component:mineRouterView,
  meta:{icon:'',right:[],isShowMenu:false,
    keepAlive:true},
  name:'',
  redirect:'/mineRouterView',
  children:[
    {path:'/mine',component:mine,name:'我的工作',meta: {right:[],isShowMenu:false,
        keepAlive:true},},
  ]
};

export default mineRouter;